import { render, staticRenderFns } from "./YearStatisticComponentWrapper.vue?vue&type=template&id=5a2f5124&"
import script from "./YearStatisticComponentWrapper.vue?vue&type=script&lang=js&"
export * from "./YearStatisticComponentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports